/* eslint-disable */
// https://vuex.vuejs.org/en/actions.html
import axios from 'axios'

//axios.defaults.baseURL = 'http://localhost/FreeTourControl/api'
axios.defaults.baseURL = 'https://app.freetoursevilla.es/api'
export default {
  
    destroyToken(context) {
      localStorage.removeItem('access_token');
      context.commit('destroyToken');
      /*
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token
    
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        axios.post('/logout.php',formData)
          .then(response => {
            localStorage.removeItem('access_token')
            context.commit('destroyToken')
            resolve(response)
            // console.log(response);
            // context.commit('addTodo', response.data)
          })
          .catch(error => {
            localStorage.removeItem('access_token')
            context.commit('destroyToken')
            reject(error)
          })
      })
    }*/
    },
    retrieveToken(context, credentials) {
      
      return new Promise((resolve, reject) => {
        
        
        let formData = new FormData();
        formData.append('username', credentials.username);
        formData.append('password', credentials.password);
        
        axios.post('/login.php', formData)
          .then(response => {
            console.log(response.data.token);
            
            if(response.data.token) {
              
              const token = response.data.token
              
              localStorage.setItem('access_token', token)
              context.commit('retrieveToken', token)
              resolve(response)
              // console.log(response);
              // context.commit('addTodo', response.data)
            }
            
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    
  
}
